import Vue from 'vue'
import {library} from '@fortawesome/fontawesome-svg-core'

import {
    faChess,
    faQuestionCircle,
    faPiggyBank,
    faUserGraduate,
    faBalanceScale,
    faRobot, faPencilAlt, faEye, faDownload, faUserSecret,
} from '@fortawesome/free-solid-svg-icons';

import {
    faCheckSquare,
    faSquare,
    faCheckCircle,
    faCircle,
} from '@fortawesome/free-regular-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

library.add(
    faBalanceScale,
    faCheckCircle,
    faCheckSquare,
    faChess,
    faCircle,
    faDownload,
    faEye,
    faPencilAlt,
    faPiggyBank,
    faQuestionCircle,
    faRobot,
    faSquare,
    faUserGraduate,
    faUserSecret,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
